import { __assign } from "tslib";
// DS: i1.4
import React from 'react';
import IconWrap from '../IconWrap';
var Llama = function (props) { return (React.createElement(IconWrap, __assign({}, props),
    React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("g", null,
            React.createElement("path", { d: "M17 5v7h1v3h-1v6h-3v-3h-1v3H9v-1H8v-3H7v-2H6v-2h1v-1h1v-1h4V5h-1V4h1V3h2v1h1V3h2v1h1v1h-1z" }))))); };
Llama.displayName = 'Llama';
export default Llama;
//# sourceMappingURL=Llama.js.map